export default __webpack_public_path__ + "assets/switch.6b97747d.svg";